module.exports = __webpack_public_path__ + "media/images/flags/gb-nir-b89f53b0520c2590b408e4dcfb1cb646.svg";